<template>
  <v-overlay style="z-index: 55" v-model="model">
    <v-row class="fill-height" justify="center" align="center">
      <div class="loader-box">
        <div class="loader"></div>
        <v-row no-gutters justify="center" align="center" style="width: 90px;height: 90px">
          <img style="width: 48px" src="logo.png"/>
        </v-row>
      </div>
    </v-row>
  </v-overlay>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel]
}
</script>

<style lang="scss">
.loader-box {
  height: 200px;
  width: 90px;
  position: relative;

  .loader {
    position: absolute;
    border: 8px solid #e1e1e1;
    border-radius: 50%;
    border-top: 8px solid #125B99;
    border-left: 8px solid #125B99;
    width: 90px;
    height: 90px;
    -webkit-animation: spin 1.8s ease-in-out infinite;
    animation: spin 1.8s ease-in-out infinite;
    background: #fff;
  }

  img {
    z-index: 1;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>